import { useState } from 'react';
import { useFormContext } from 'react-hook-form/dist/index.ie11';
import { useCorporateFormContext } from 'src/components/enterprise/features/Corporate/components/Form/CorporateFormProvider/useCorporateFormContext';

type useUnselectCheckboxConfirmationReturnType = {
  confirmationModalOpen: boolean;
  closeConfirmationModal: () => void;
  setFieldValue: (value: boolean) => void;
  onChangeCheckedFeature: (checked: boolean) => void;
};

export function useUnselectCheckboxConfirmation(
  name: string
): useUnselectCheckboxConfirmationReturnType {
  const { setValue } = useFormContext();
  const { isEditPage, corpData } = useCorporateFormContext();
  const [confirmationModalOpen, setConfirmationModalOpen] = useState(false);

  const closeConfirmationModal = (): void => {
    setConfirmationModalOpen(false);
  };

  const setFieldValue = (value: boolean): void => {
    setValue(name, value);
    closeConfirmationModal();
  };

  const onChangeCheckedFeature = (checked): void => {
    if (isEditPage && corpData[name] && !checked) {
      setFieldValue(true);
      setConfirmationModalOpen(true);
    }
  };

  return {
    confirmationModalOpen,
    closeConfirmationModal,
    setFieldValue,
    onChangeCheckedFeature,
  };
}
